import { AlertTriangle, Calculator, HelpCircle } from "lucide-react";
import { ReactNode } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/Tooltip";
import { MetricTooltipData } from "@/types/metrics";

interface MetricTooltipProps {
  tooltip: MetricTooltipData;
  children: ReactNode;
}

export function MetricTooltip({ tooltip, children }: MetricTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side="top" className="max-w-sm p-3 space-y-2">
          <p className="text-sm text-gray-100">{tooltip.description}</p>

          {tooltip.formula && (
            <div className="flex items-start gap-2 pt-1 border-t border-gray-600">
              <Calculator className="h-4 w-4 text-blue-400 shrink-0 mt-0.5" />
              <p className="text-xs text-blue-300 font-mono">
                {tooltip.formula}
              </p>
            </div>
          )}

          <div className="flex items-start gap-2 pt-1 border-t border-gray-600">
            <HelpCircle className="h-4 w-4 text-emerald-400 shrink-0 mt-0.5" />
            <p className="text-xs text-emerald-300">{tooltip.answersQuestion}</p>
          </div>

          {tooltip.watchOut && (
            <div className="flex items-start gap-2 pt-1 border-t border-gray-600">
              <AlertTriangle className="h-4 w-4 text-amber-400 shrink-0 mt-0.5" />
              <p className="text-xs text-amber-300">{tooltip.watchOut}</p>
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
